import { connect } from 'react-redux';
import CalendarEvent from 'components/CalendarEvent/CalendarEvent';
import { endOfDay } from 'utils/calendar-utils';
import { selectCalendarEvent } from 'actions/Calendar';
import { ONE_DAY, FIFTEEN_MINUTES } from 'constants/Calendar';
import { injectIntl, defineMessages } from 'react-intl';
import _get from 'lodash/get';

const messages = defineMessages({
  noTitle: { id: 'components.calendarEvent.noTitle', defaultMessage: '(No Title)' },
});

const mapStateToProps = (state, ownProps) => {
  const event = ownProps.event;
  const extension = _get(event, 'extension');
  const title = _get(event, 'title') || ownProps.intl.formatMessage(messages.noTitle);
  let totalDays = 0;
  let isLastDay = false;

  let hasUpcomingTime = typeof _get(state, ['app', 'calendar', 'upcomingNotifications', ownProps.event.id]) === 'number';
  const nowTime = new Date();
  const startDateTime = _get(event, 'start.dateTime');
  const endDateTime = _get(event, 'end.dateTime');
  const startDateOnly = _get(event, 'start.date');
  const endDateOnly = _get(event, 'end.date');

  const startDate = _get(event, 'startDate');
  const endDate = _get(event, 'endDate');

  const meetingStart = startDateTime ? startDate.getTime() : endOfDay(startDateOnly);
  const meetingEnd = endDateTime ? endDate.getTime() : endOfDay(endDateOnly);
  const meetingLengthInDaysExact = (meetingEnd - meetingStart) / ONE_DAY;

  const meetingLengthInDays = Math.ceil(meetingLengthInDaysExact);
  const meetingDay = new Date(ownProps.targetDay);
  if ((meetingDay.getTime() - nowTime.getTime()) > FIFTEEN_MINUTES) {
    // The meeting is technically happening "now" but don't show that if the day is in the future
    hasUpcomingTime = false;
  }

  let currentDay = Math.max(Math.abs(Math.ceil((meetingDay.getTime() - meetingStart) / ONE_DAY)), 1);

  let startDateNumber;
  let endDateNumber;
  let oneFullDay;
  if (startDate) {
    startDateNumber = startDateTime ? startDate.getDate() : startDate.getUTCDate();
  }

  if (endDate) {
    endDateNumber = endDateTime ? endDate.getDate() : endDate.getUTCDate() - 1;
  }

  if (startDate) {
    oneFullDay = startDate.getHours() === 0 && meetingLengthInDaysExact === 1;
  }

  if (
    meetingLengthInDays > 1
  ) {
    totalDays = meetingLengthInDays;
    if (meetingDay.getDate() === new Date(new Date(endDate).setMilliseconds(-1)).getDate()) {
      currentDay = totalDays;
    }
  } else if (!oneFullDay && startDateNumber !== endDateNumber) {
    totalDays = 2;
    if (endDate) {
      isLastDay = meetingDay.getDate() === endDate.getDate();
    }
    if (isLastDay) {
      currentDay = 2;
    }
  }

  return {
    currentDay,
    event,
    extension,
    hasUpcomingTime,
    title,
    totalDays
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  selectEvent: () => {
    dispatch(selectCalendarEvent(_get(ownProps, 'event.id')));
  }
});

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(CalendarEvent)
);
